import React, { useState, useRef } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import './ShareModal.scss';

function ShareModal({ url }) {
    const [show, setShow] = useState(false);
    const [copyButtonText, setCopyButtonText] = useState('Copy')
    const textInput = useRef(null);

  
    const handleClose = () => {
        setShow(false);
        setCopyButtonText('Copy');
    }
    const handleShow = () => setShow(true);

    const handleCopy = () => {
        textInput.current.select();
        document.execCommand('copy');
        setCopyButtonText('Copied!')
    };
  
    return (
      <>
        <button className="btn btn-link share-modal-btn" onClick={handleShow} >
          <FontAwesomeIcon style={{verticalAlign:"middle" }} icon={['fas', 'share-square']} />
        </button>
  
        <Modal show={show} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>Share</Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ textAlign: 'center' }} className="share-modal">
                <input ref={textInput} type="text" value={url} readOnly />{' '}
                <Button variant="secondary" onClick={handleCopy}>
                    {copyButtonText}
                </Button>
                <br />
                <a target="_blank" href={`mailto:?subject=Sharing a link from ${global.drupalSettings.catalogues.sale_name}&body=Check this out from ${global.drupalSettings.catalogues.sale_name}.  ${url}`}>
                    <FontAwesomeIcon style={{verticalAlign:"middle" }} icon={['far', 'envelope']} size="lg" />
                </a>
                <a target="_blank" href={`https://www.facebook.com/sharer/sharer.php?u=${url}`}>
                    <FontAwesomeIcon style={{verticalAlign:"middle" }} icon={['fab', 'facebook-f']} size="lg" />
                </a>
                <a target="_blank" href={`http://twitter.com/intent/tweet?text=Check+Out+This+Link+From+${global.drupalSettings.catalogues.sale_name}.&url=${url}`}>
                    <FontAwesomeIcon style={{verticalAlign:"middle" }} icon={['fab', 'twitter']}  size="lg"/>
                </a>

          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }

  export default ShareModal;
